<template>
<tr :key="skill.id" class="bg-white hover:bg-gray-200 focus-within:bg-gray-200 text-center cursor-pointer">
                                         <td class="text-1xl font-semibold border-t">
                                             {{skill.skill}}
                                         </td>
                                         <td class="border-t text-center">Complete</td>
                                         <td class="border-t text-center">{{getDefinition(skill.expiry_date)}}</td>
                                         <td class="border-t text-center">{{toBasicDate(skill.achieved_date)}}</td>
                                        <td class="border-t text-center">{{toBasicDate(skill.expiry_date)}}</td>
                                        <td class="border-t text-center"><button class="bg-black text-white font-bold rounded p-3 mx-3 my-2" @click="setEvidence()">View evidence</button></td>
                                        <td class="border-t w-px">
                                        </td>
</tr>   
<tr v-if="showEvidence">
   <td> <img class="inline" v-for="(evidence,key) in skill.supporting_evidence" :key="key" :src="'/evidence/' + evidence.document_name "  width="250" height="250" alt=""></td>
</tr>
</template>

<script>
import moment from 'moment'
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
       data() {
        return {
        showEvidence : false
        }},
    components : {
        Link,Head
    },
    props : {
        skill : Object,
    },
    methods : {
          setEvidence(){
              if (this.showEvidence) {
                  this.showEvidence = false

              }else{
                  this.showEvidence = true
              }
          },
            getDefinition(expdate){
                let now = moment()
                let date = moment(expdate)
                var diff = now.diff(date,'days');
                // to do pending
                if(diff>0){
                    return 'Expired';
                }
                else if(diff>=-90){
                    return 'Pending Expiry';
                }
                else{
                    return 'In date';
                }
            },
        backChange(e){
            e.preventDefault();
            const file = e.target.files[0];
            this.form.back_card = file;
            this.back_card = URL.createObjectURL(file);
        },
        toBasicDate(inputdate){
           return  moment(inputdate).format("DD/MM/Y")
        }
    }
}
</script>